import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from '@ora/recursos/src/redux/actions/DataPageAction'
import { connect } from "react-redux";
import { createHChart } from "layouts/mainsection/components/CHighchartToolsTraffic";

class MOEspeDetecEncontrada extends Component {
 
  componentDidMount () {
  
    
  }
  render () {
    
    
    return this.props.data.length > 0 ? <> {createHChart('PhartMOEspeDetecEncontrada',
    {
      chart: { type: 'bar' },
      title: { text: this.props.title },
      legend: {
        enabled: false
      },
      plotOptions: {
        bar: {
            dataLabels: {
                enabled: true
            }
        }
    },
      xAxis: { 
        title: { 
          text: 'Lugar',
        enabled: false
        }, 
        // width: 100,
        //tickWidth: 100,
        categories:  this.props.data.map(item => (item.producto))
      },
      yAxis: {
        
          min: 0,
          title: {
              text: 'Cantidad',
              enabled: false
          }
      },
      // legend: { enabled: false },
      plotOptions: {
          series: {
              // stacking: 'normal',
              //pointWidth: 30
          }
      },
      series: [{
          name: 'Cantidad',
          colorByPoint: true,
          data: this.props.data.map(item => (item.cantidad))
      }]
    }
    )} 
    <div style={{fontSize: '0.9em'}}>

      <div className="has-text-centered" style={{fontSize: '0.9em'}}>
        <p className="px-6" style={{
        color: '#000',
        fontSize: '1.1em',
        
        fill: '#000'
        }}><i>{ this.props.description }</i></p>
      </div>
      </div>
      </>
    : null
    
  }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(MOEspeDetecEncontrada)